@let profilesLength = profiles().length;
@let isSuperAdmin = isSuperAdmin$ | async;

@if (profilesLength > 1 || isSuperAdmin) {
  <div
    class="d-flex align-items-center menu-item logged-company"
    [matMenuTriggerFor]="profileMenu">
    @if (loadedProfile(); as activeProfile) {
      <a
        class="d-flex mat-menu-trigger"
        data-cy="main-nav-profiles">
        <sh-profile-logo
          class="rounded-circle mr-2 logo user-avatar"
          [hasLogo]="activeProfile.hasLogo"
          [id]="activeProfile.id"
          [logoImageType]="activeProfile.logoImageType"
          [logoTheme]="activeProfile.logoTheme"
          [logoVersion]="activeProfile.logoVersion"
          [profileTitle]="activeProfile.title"></sh-profile-logo>

        <div class="d-flex flex-column justify-content-center">
          <a
            class="font-weight-bold"
            data-cy="main-nav-profiles-company-name"
            [attr.title]="activeProfile?.title">
            {{ activeProfile?.title }}
          </a>
        </div>
      </a>
    } @else {
      <a
        class="font-weight-bold"
        [attr.title]="'header.profiles' | transloco">
        {{ 'header.profiles' | transloco }}
      </a>
    }
    <div class="d-flex align-items-center">
      <mat-icon>expand_more</mat-icon>
    </div>
  </div>
} @else {
  <div class="d-flex align-items-center menu-item logged-company">
    @if (loadedProfile(); as activeProfile) {
      <a
        class="d-flex mat-menu-trigger"
        data-cy="main-nav-profiles">
        <sh-profile-logo
          class="rounded-circle mr-2 logo user-avatar"
          [hasLogo]="activeProfile.hasLogo"
          [id]="activeProfile.id"
          [logoImageType]="activeProfile.logoImageType"
          [logoTheme]="activeProfile.logoTheme"
          [logoVersion]="activeProfile.logoVersion"
          [profileTitle]="activeProfile.title"></sh-profile-logo>

        <div class="d-flex flex-column justify-content-center">
          <a
            class="font-weight-bold"
            data-cy="main-nav-profiles-company-name"
            [attr.title]="activeProfile?.title">
            {{ activeProfile?.title }}
          </a>
        </div>
      </a>
    } @else {
      <a
        class="font-weight-bold"
        [attr.title]="'header.profiles' | transloco">
        {{ 'header.profiles' | transloco }}
      </a>
    }
  </div>
}

<mat-menu
  class="header-menu"
  #profileMenu="matMenu">
  @for (profileWhereUserIsAdmin of profiles() | orderBy: 'title'; track profileWhereUserIsAdmin.title) {
    <a
      class="header-menu-item"
      mat-menu-item
      [routerLink]="profileLink(profileWhereUserIsAdmin)"
      >{{ profileWhereUserIsAdmin.title }}</a
    >
  }

  @if (isSuperAdmin) {
    @if (profilesLength > 0) {
      <div class="my-2 header-menu-divider"></div>
    }

    <a
      class="header-menu-item"
      mat-menu-item
      (click)="navigateToCreateProfile()">
      {{ 'header.user-menu.create-new-profile' | transloco }}
    </a>
  }
</mat-menu>
